import React, { ErrorInfo, ReactNode } from 'react'

export type AppErrorHandlerProps = {
  children?: ReactNode
  fallback?: ReactNode
}

type AppErrorHandlerState = {
  hasError: boolean
  error?: Error
  errorInfo?: ErrorInfo
}

export default class AppErrorHandler extends React.Component<
  AppErrorHandlerProps,
  AppErrorHandlerState
> {
  constructor(props: AppErrorHandlerProps) {
    super(props)
    this.state = { hasError: false }
  }
  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    console.info(error, errorInfo)
    this.setState({
      hasError: true,
      error: error,
      errorInfo: errorInfo
    })
  }
  render(): React.ReactNode {
    return this.state.hasError
      ? this.props.fallback || (
          <>
            <p>Error catch</p>
            <p>{this.state.error?.name}</p>
            <p>{this.state.errorInfo?.componentStack}</p>
          </>
        )
      : this.props.children
  }
}
